import { Box, PageWrapper } from '@oresundsbron/bridge-ui';
import { useRouter } from 'next/router';
import { FC, useEffect, useRef } from 'react';
import { SEOMetadata } from '../components/SEOMetadata';
import { usePage } from '../hooks/usePage';

export const CookiePolicy: FC<{ id: string }> = ({ id }) => {
  const wrapper = useRef<HTMLDivElement>();
  const { locale } = useRouter();
  const { page, seoMetadata } = usePage({ id });

  useEffect(() => {
    if (!wrapper.current) {
      return;
    }

    if (!!document.querySelector('#CookiePolicy')) {
      return;
    }

    if (process.env.NODE_ENV === 'development') {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('id', 'CookiePolicy');
    script.setAttribute(
      'src',
      'https://policy.app.cookieinformation.com/cid.js'
    );
    script.setAttribute('data-culture', locale?.toUpperCase() || '');
    script.setAttribute('type', 'text/javascript');

    wrapper.current.appendChild(script);
  }, [locale]);

  if (!page) {
    return null;
  }

  return (
    <PageWrapper as="main">
      <SEOMetadata items={seoMetadata} />
      <Box
        className="col-start-2 py-6 sm:py-8"
        id="cookiePolicyParent"
        ref={wrapper}
      ></Box>
    </PageWrapper>
  );
};
